module.exports = __webpack_public_path__ + "img/beyond_logo_cyrcle-white.9b29f7cd.png";